import React, { useEffect, useState } from 'react'
import { useHistory } from "react-router-dom";
import PropTypes from 'prop-types';
import axios from 'axios'
import moment from 'moment'
import { makeStyles } from '@material-ui/core/styles';
import CssBaseline from '@material-ui/core/CssBaseline';
import Grid from '@material-ui/core/Grid';
import Container from '@material-ui/core/Container'
import Typography from '@material-ui/core/Typography';
import Paper from '@material-ui/core/Paper';
import TextField from '@material-ui/core/TextField';
import DateFnsUtils from '@date-io/date-fns';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import FormHelperText from '@material-ui/core/FormHelperText';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';
import {
    MuiPickersUtilsProvider,
    KeyboardDatePicker
} from '@material-ui/pickers';
import AppBar from '@material-ui/core/AppBar';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import Box from '@material-ui/core/Box';

import ProvinsiData from '../Biodata/ProvinsiData'
import KabupatenData from '../Biodata/KabupatenData'


export default function Biodata(user) {
    return (
        <div>
            <TextField
                label="No. Registrasi"
                type="string"
                InputLabelProps={{
                    shrink: true,
                }}
                fullWidth
                disabled
                variant="outlined"
                value={user.reg_no}
            />
            <TextField
                label="Nama Depan"
                type="string"
                InputLabelProps={{
                    shrink: true,
                }}
                fullWidth
                disabled
                variant="outlined"
                value={user.first_name}
            />
            <TextField
                label="Nama Belakang"
                type="string"
                InputLabelProps={{
                    shrink: true,
                }}
                fullWidth
                disabled
                variant="outlined"
                value={user.last_name}
            />
            <TextField
                label="Nomor Telepon"
                type="string"
                InputLabelProps={{
                    shrink: true,
                }}
                fullWidth
                disabled
                variant="outlined"
                value={user.no_wa}
            />
            <TextField
                label="Username Zoom"
                type="string"
                InputLabelProps={{
                    shrink: true,
                }}
                fullWidth
                disabled
                variant="outlined"
                value={user.zoom_user}
            />
        </div>
    )
}